// extracted by mini-css-extract-plugin
module.exports = {"container":"UserMenu_container__1cF2Y","name":"UserMenu_name__34ORG"};